import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/dashboard/Dashboard';
import Discover from './components/discover/Discover';
import Messages from './components/messages/Messages';
import Videos from './components/media/Videos';
import Photos from './components/media/Photos';
import ProfileView from './components/profile/ProfileView';
import MyProfile from './components/profile/MyProfile';
import Favorites from './components/dashboard/Favorites';
import Visits from './components/dashboard/Visits';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './styles/global.css';

// Composant pour déboguer l'authentification (optionnel)
const AuthDebugger = () => {
  const { user, loading } = useAuth();
  console.log('🔄 App - Auth state:', { user, loading });
  return null;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* Commenter ou supprimer cette ligne si vous ne voulez pas de logs */}
        {/* <AuthDebugger /> */}
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1a0f0f',
              color: '#fff',
              border: '1px solid rgba(255, 59, 59, 0.3)',
              borderRadius: '12px',
            },
          }}
        />
        
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="discover" element={<Discover />} />
            <Route path="messages" element={<Messages />} />
            <Route path="videos" element={<Videos />} />
            <Route path="photos" element={<Photos />} />
            <Route path="profile/:id" element={<ProfileView />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="visits" element={<Visits />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;